module.exports = __webpack_public_path__ + "static/img/stationery_.2d93116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stationery_.png
// module id = rCUp
// module chunks = 18